import React from 'react'
import Heading from '../../common/Heading'
import './slide.css'
import SlideCard from './SlideCard'
import CollectionCard from './CollectionCard'

function Slide() {
    return (
      <>
        <section className="featured background">
          <div className="container">
            <Heading title='Explore our latest collection' subtitle=" 
              Our latest collection is now live, featuring stunning tablescapes, 
              decadent desserts, and savory cuisine that will leave your guests in awe. 
              From weddings and galas to corporate events and social gatherings, 
              our expert team will work with you to bring your vision to life." />

              {/* Browse our latest collection now and let's get started on creating unforgettable memories! */}
              
              <CollectionCard/>
              <SlideCard/>
          </div>
        </section>
      </>
    )
  }

export default Slide